'use client';

import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';

import { BotGuardFields } from '@/lib/bot-guard';

export interface HoneypotHandle {
	isFilled: () => boolean;
	// Sent to the server action, which checks it with isLikelyBot.
	getGuardFields: () => BotGuardFields;
}

const Honeypot = forwardRef<HoneypotHandle>((_, ref) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const mountedAtRef = useRef<number | null>(null);

	useEffect(() => {
		mountedAtRef.current = Date.now();
	}, []);

	useImperativeHandle(ref, () => ({
		isFilled: () => !!inputRef.current?.value,
		getGuardFields: () => ({
			honeypot: inputRef.current?.value ?? '',
			fillTimeMs: mountedAtRef.current === null ? undefined : Date.now() - mountedAtRef.current
		})
	}));

	return (
		<input
			ref={inputRef}
			type="text"
			name="company_url"
			autoComplete="off"
			tabIndex={-1}
			aria-hidden="true"
			style={{ display: 'none' }}
		/>
	);
});

export default Honeypot;
